import React from 'react';
import mailIcon from '../assets/figma/footer-mail.svg';
import divider from '../assets/figma/footer-divider.svg';
import linkedinIcon from '../assets/figma/footer-linkedin.svg';
import githubIcon from '../assets/figma/footer-github.svg';

const Footer = () => (
  <footer className="footer-section" id="contact-section">
    <div className="footer-content">
      <div className="footer-cta-block">
        <div className="footer-kicker">
          <span className="footer-kicker-dot" />
          <span>Get in Touch</span>
        </div>
        <h2>Let&apos;s connect and build something together.</h2>
        <p>
          I am actively seeking software engineering internships and full-time opportunities.
          Drop me an email or find me on digital platforms.
        </p>
        <a className="footer-email-button" href="mailto:kaustubh.bhosale30@gmail.com">
          <img src={mailIcon} alt="" aria-hidden="true" />
          <span>kaustubh.bhosale30@gmail.com</span>
        </a>
      </div>

      <img className="footer-divider" src={divider} alt="" aria-hidden="true" />

      <div className="footer-bottom-row">
        <div className="footer-credit">
          {/* <p>© 2026 Kaustubh Bhosale</p> */}
          <p>改善 • Kaizen — continuous improvement, one step at a time.</p>
        </div>
        <div className="footer-social-links">
          <a href="https://www.linkedin.com/in/kaustubh-bhosale-331956256/" target="_blank" rel="noreferrer">
            <img src={linkedinIcon} alt="" aria-hidden="true" />
            <span>LinkedIn</span>
          </a>
          <a href="https://github.com/Sipher2003" target="_blank" rel="noreferrer">
            <img src={githubIcon} alt="" aria-hidden="true" />
            <span>GitHub</span>
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
